exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-description .btn[data-v-771c0fe5] {\n  cursor: pointer;\n}\n.button-outline[data-v-771c0fe5] {\n  border: 2px solid;\n  height: 40px;\n  width: 220px;\n  border-radius: 24px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n", ""]);

// exports
